import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

export type GetGoodsSupplyPriceResponse = {
  ItemCode: '',
  CoopCode: '',
  SupplyPriceStandard: 0,
  SupplyPriceSpecial1: 0,
  SupplyPriceSpecial2: 0,
};

/**
 * 商品会員生協供給価格取得
 *
 * @export GetGoodsSupplyPriceService
 * @class GetGoodsSupplyPriceService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsSupplyPriceService extends PlessJsonResponderSub<GetGoodsSupplyPriceResponse[]> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGoodsSupplyPriceService
   */
  private successFunc: Function = () => {};

  model: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsSupplyPriceService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.model.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetGoodsSupplyPriceService
   */
  execute(model: any, successFunc: Function = () => {}): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getGoodsSupplyPrice', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsSupplyPriceService
   */
  success(data: GetGoodsSupplyPriceResponse[]): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}